var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.page.about)?_c('div',{staticClass:"page page-white page-about"},[_c('div',{staticClass:"page-about-hidden"},[_c('AboutMainText')],1),_vm._v(" "),_c('div',{staticClass:"about-map"},[_c('img',{attrs:{"src":"/static/map_white.svg"}}),_vm._v(" "),_c('Cities')],1)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6526121a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/AboutUsMap.vue
// module id = 268
// module chunks = 0